export const STATUS = {
  FAILED: 'failed',
  FETCHING: 'fetching',
  FINISHED: 'finished',
};
